import type { RechercheQueryDTO, RechercheResultDTO } from '@/features/api/extranet/dto/Demande/Recherche'
import { buildRechercheStore } from '../storeRechercheBuilder'

export const useRechercheDemandeStore = buildRechercheStore<RechercheQueryDTO, RechercheResultDTO>({
  storeName: 'rechercheDemandeStore',
  apiPath: '/demandes',
})

